import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EAmenityType } from '../../../../api-models/common/json_query';

const ID = 'amenity' as const;

const AMENITY_LABELS: Record<EAmenityType, string> = {
  [EAmenityType.Wifi]: 'Wi-Fi',
  [EAmenityType.BikeParking]: 'Велопарковка',
  [EAmenityType.Internet]: 'Высокоскоростной интернет',
  [EAmenityType.RestZone]: 'Зоны отдыха',
  [EAmenityType.Cafe]: 'Кафе',
  [EAmenityType.Cleaning]: 'Клининг',
  [EAmenityType.Kitchen]: 'Кухня',
  [EAmenityType.Furniture]: 'Мебель',
  [EAmenityType.Security]: 'Охрана',
  [EAmenityType.Parking]: 'Парковка',
  [EAmenityType.MeetingRoom]: 'Переговорные комнаты',
  [EAmenityType.Printer]: 'Принтер и сканер',
  [EAmenityType.Reception]: 'Ресепшн',
  [EAmenityType.Modern]: 'Современный ремонт',
  [EAmenityType.Gym]: 'Спорт-зал',
  [EAmenityType.PhoneBooth]: 'Телефонные будки',
  [EAmenityType.TechSupport]: 'Техническая поддержка',
  [EAmenityType.Events]: 'Участие в мероприятиях',
  [EAmenityType.Fax]: 'Факс',
  [EAmenityType.Flipchart]: 'Флипчарт',
  [EAmenityType.Fruits]: 'Фрукты и закуски',
  [EAmenityType.Tea]: 'Чай/кофе',
  [EAmenityType.Lockers]: 'Шкафчики',
  [EAmenityType.LegalAddress]: 'Юридический адрес',
};

export const amenityTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const types = getTermsValue('amenity')(jsonQuery);

    if (types === null) {
      return null;
    }

    return types.map(t => ({
      label: AMENITY_LABELS[t],
      value: createTagValue(ID, t.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const types = getTermsValue('amenity')(jsonQuery);

    if (types === null) {
      return jsonQuery;
    }

    const next = types.filter(t => String(t) !== removingTagValue);

    return next.length > 0 ? setTerms('amenity')(jsonQuery)(next) : resetTerms(['amenity'])(jsonQuery);
  },
};
